/*
   stickyfloat - jQuery plugin for vertically floating anything in a constrained area

   This plugin has been customized for MLT use.  Make sure to bring over changes if you upgrade.

   Example: jQuery('#menu').stickyfloat({duration: 400});
   parameters:
        duration        (number, 200) - the duration of the animation
        startOffset     (number) - the amount of scroll offset after the animations kicks in
        offsetY         (number) - the offset from the top when the object is animated
        delay           (number, 0) - delay in milliseconds  until the animations starts
        easing          (string, linear) - easing function (jQuery has by default only 'swing' & 'linear')
        parent          (object, null) - optional parent element to use

   $Version: 06.01.2012 r7 (jau - fixed issues found trying to use with new MLT layout, removed stickToBottom)
   $Version: 06.01.2012 r6 (jau - added parent parameter, removed postion:absolute, use parent bottom instead of window)
   $Version: 08.04.2012 r5 (bug fixes)
   $Version: 12.02.2012 r4 (bus fixes, added 'stickToBottom')
   $Version: 11.28.2011 r3
   $Version: 08.10.2011 r2
   $Version: 05.16.2009 r1

   Copyright (c) 2012 Yair Even-Or
   vsync.design@gmail.com
 */
(function($) {

    $.fn.stickyfloat = function(options) {

        var $obj                = this,
            doc                 = $(document),
            $parent             = options.parent || $obj.parent(),
            parentPaddingTop    = parseInt($parent.css('padding-top'), 10),
            objPaddingTop       = parseInt($obj.css('padding-top'), 10),
            startOffset         = $obj.offset().top,
            opts                = $.fn.stickyfloat.opts;

        $.extend(opts, { startOffset: startOffset, offsetY: parentPaddingTop }, options);

        function initFloat(){
            var topPos, pastStartOffset, objFartherThanTopPos, objSmallerThanParent, newpos;

            // stop all calculations on scroll event
            $obj.stop();

            // get the maximum top position
            topPos = ($parent.height() + $parent.position().top) - $obj.outerHeight() - opts.startOffset - objPaddingTop;
            topPos = topPos < 0 ? 0 : topPos;

            // check if the window was scrolled down more than the start offset declared.
            pastStartOffset = doc.scrollTop() > opts.startOffset;

            // check if the object is at it's top position (starting point)
            objFartherThanTopPos = $obj.offset().top > startOffset;

            // check if object is smaller than parent
            objSmallerThanParent = $obj.outerHeight() < ($parent.height() - opts.startOffset);

            if ((pastStartOffset || objFartherThanTopPos) && objSmallerThanParent) {
                newpos = doc.scrollTop() - startOffset + opts.offsetY;
                if (newpos > topPos) {
                    newpos = topPos;
                // if window scrolled < starting offset, then reset Obj position (opts.offsetY);
                } else if (doc.scrollTop() < opts.startOffset) {
                    newpos = opts.offsetY;
                }
                if (opts.duration > 5) {
                    $obj.stop().delay(opts.delay).animate({ top: newpos }, opts.duration, opts.easing );
                } else {
                    $obj.stop().css('top', newpos);
                }
            } else {
                $obj.stop().css('top', opts.offsetY);
            }
        }

        $(window).bind('scroll.sticky', initFloat);
    };

    $.fn.stickyfloat.opts = { duration: 200, delay: 0, easing: 'linear' };

})(jQuery);